<div mat-dialog-title>{{ message }}</div>

<mat-dialog-content class="dialog-content">
  <!-- Spinner always visible -->
  <div class="spinner-container">
    <mat-spinner class="center"></mat-spinner>
  </div>

  <!-- Progress list with template reference -->
  <div #progressList class="progress-list">
    <div *ngFor="let msg of progressUpdates" class="progress-item" [ngClass]="msg.status">
      <strong>{{ msg.processName }}</strong> - {{ msg.status }}
    </div>
  </div>
</mat-dialog-content>
